<template>
  <v-card>
    <!-- tab control -->
    <v-card class="d-flex justify-space-around align-center">
      <div bottom class="text-h5">Dashboard de Ventas</div>
    </v-card>
    <!-- tab0 list -->
    <v-card-text>
      <v-card>
        <!-- advanced filter -->
        <v-toolbar>
          <v-autocomplete
            label="Campaña"
            :items="campaignItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaign"
            return-object
            @change="campaignSelected($event)"
            ref="campaignAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('campaignAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Seg.Prod. Campaña Actual"
            :items="campaignSegmentationItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="code"
            item-value="url"
            v-model="selectedCampaignSegmentation"
            return-object
            @change="campaignSegmentationSelected($event)"
            ref="campaignSegmentationAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="
              clearAutocomplete('campaignSegmentationAutocomplete')
            "
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Cultivo"
            :items="cropItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="url"
            v-model="selectedCrop"
            return-object
            @change="cropSelected($event)"
            ref="cropAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('cropAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Comercial"
            :items="commercialPersonItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="name"
            item-value="commercial_person"
            return-object
            @change="commercialPersonSelected($event)"
            ref="commercialPersonAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('commercialPersonAutocomplete')"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-autocomplete
            label="Columna Estimados"
            :items="estimationColumnsItems"
            hide-details
            hide-no-data
            hide-selected
            item-text="description"
            item-value="code"
            v-model="selectedEstimationColumn"
            return-object
            @change="estimationColumnSelected($event)"
            ref="estimationColumnAutocomplete"
            prepend-icon="mdi-close"
            @click:prepend="clearAutocomplete('estimationColumnAutocomplete')"
          ></v-autocomplete>
          <v-progress-linear
            :active="loading"
            indeterminate
            absolute
            bottom
          ></v-progress-linear>
        </v-toolbar>
      </v-card>
      <div v-show="pivotLoaded" id="pivot-container" class="mt-2"></div>
    </v-card-text>
  </v-card>
</template>
<script>
import WebDataRocks from "webdatarocks";
import "webdatarocks/webdatarocks.min.css";
import "webdatarocks/webdatarocks.toolbar";
import wdrEs from "@/assets/webDataRocksEs.json";

export default {
  name: "SalesDashboard",

  components: {
    //
  },

  data() {
    return {
      editMode: "show",
      campaignItems: [],
      campaignSegmentationItems: [],
      cropItems: [],
      estimationColumnsItems: [],
      commercialPersonItems: [],
      filterCampaign: null,
      filterCrop: null,
      filterEstimationClolumn: null,
      filterCommercialPerson: null,
      filterCampaignSegmentation: null,
      selectedCampaign: null,
      selectedCampaignSegmentation: null,
      selectedCrop: null,
      selectedEstimationColumn: null,
      campaignPreviousIdSegmentation: null,
      pivot: null,
      pivotLoaded: false,
      loading: true
    };
  },

  methods: {
    //Reading data from API method.
    async readDataFromAPI() {
      try {
        if (
          this.filterCampaign &&
          this.filterCrop &&
          this.filterEstimationClolumn &&
          this.filterCampaignSegmentation
        ) {
          this.loading = true;
          let endpoint =
            "/data/sales_dashboard/" +
            this.filterCampaign.id.toString() +
            "/" +
            this.filterCrop.id.toString() +
            "/";
          /* eslint-disable */
          switch (this.filterCommercialPerson ? this.filterCommercialPerson.commercial_type_level : 0) {
            case 0:
              endpoint = endpoint + "0/0/0";
              break;
            case 1:
              /* eslint-disable */
              endpoint = endpoint + this.filterCommercialPerson.commercial_id.toString() + "/0/0";
              break;
            case 2:
              /* eslint-disable */
              endpoint = endpoint + "0/" + this.filterCommercialPerson.commercial_id.toString() + "/0";
              break;
            case 3:
              /* eslint-disable */
              endpoint = endpoint + "0/0/" + this.filterCommercialPerson.commercial_id.toString();
              break;
          }
          endpoint =
            endpoint +
            "/" +
            this.filterEstimationClolumn.code +
            "/" +
            this.filterCampaignSegmentation.id.toString() +
            "/" +
            this.campaignPreviousIdSegmentation.toString();
          let response = await this.$bRoot.search(endpoint);
          let title =
            this.filterCampaign.description +
            ", Cultivo: " +
            this.filterCrop.description +
            /* eslint-disable */
            (this.filterCommercialPerson ? ", Comercial: " + this.filterCommercialPerson.name : "") +
            ", Columna Estimados: " +
            this.filterEstimationClolumn.id.toString() +
            ", Segmentación Prod. Campaña Actual en base a Relevamientos " +
            this.filterCampaignSegmentation.description +
            " (" +
            this.$moment().format("DD/MM/YYYY h:mm a") +
            ")";
          await this.loadPivotTable(response.data, title);
          this.pivotLoaded = true;
        } else {
          this.pivotLoaded = false;
          this.unloadPivotTable();
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      } finally {
        this.loading = false;
      }
    },

    async clearAutocomplete(field) {
      this.$refs[field].internalValue = [];
      switch (field) {
        case "campaignAutocomplete":
          this.filterCampaign = null;
          this.selectedCampaign = null;
          await this.loadColumns();
          this.refreshCampaignSegmentation();
          break;
        case "campaignSegmentationAutocomplete":
          this.filterCampaignSegmentation = null;
          this.selectedCampaignSegmentation = null;
          break;
        case "estimationColumnAutocomplete":
          this.filterEstimationClolumn = null;
          break;
        case "cropAutocomplete":
          this.filterCrop = null;
          break;
        case "commercialPersonAutocomplete":
          this.filterCommercialPerson = null;
          break;
      }
      await this.readDataFromAPI();
    },

    async campaignSelected(item) {
      this.filterCampaign = item;
      await this.loadColumns();
      await this.refreshCampaignSegmentation();
      await this.readDataFromAPI();
    },

    async estimationColumnSelected(item) {
      this.filterEstimationClolumn = item;
      await this.readDataFromAPI();
    },

    async cropSelected(item) {
      this.filterCrop = item;
      await this.readDataFromAPI();
    },

    async commercialPersonSelected(item) {
      this.filterCommercialPerson = item;
      await this.readDataFromAPI();
    },

    async campaignSegmentationSelected(item) {
      this.filterCampaignSegmentation = item;
      await this.readDataFromAPI();
    },

    refreshCampaignSegmentation() {
      this.filterCampaignSegmentation = null;
      this.selectedCampaignSegmentation = null;
      this.campaignPreviousIdSegmentation = null;
      this.campaignSegmentationItems = [];

      if (this.campaignSelected) {
        this.campaignSegmentationItems.push(this.filterCampaign);
        if (this.filterCampaign.previous_campaign) {
          /* eslint-disable */
          let index = this.campaignItems.findIndex(item => item.url === this.filterCampaign.previous_campaign);
          if (index !== -1) {
            this.campaignSegmentationItems.push(this.campaignItems[index]);
            this.campaignPreviousIdSegmentation = this.campaignItems[index].id;
          }
        } else {
          this.campaignPreviousIdSegmentation = this.filterCampaign.id;
        }
        this.filterCampaignSegmentation = this.filterCampaign;
        this.selectedCampaignSegmentation = this.filterCampaign.url;
      }
    },

    async loadPivotTable(data, title) {
      /*Crear Pivot Table*/
      this.pivot = new WebDataRocks({
        container: "#pivot-container",
        toolbar: true,
        customizeCell: (cellBuilder, cellData) => {
          if (cellData.measure) {
            switch (cellData.measure.uniqueName) {
              case "metrica_70":
                cellBuilder.addClass("alter1");
                break;
              case "metrica_100":
                cellBuilder.addClass("alter2");
                break;
              case "metrica_130":
                cellBuilder.addClass("alter3");
                break;
            }
          }
        },
        beforetoolbarcreated: this.customizeToolbar,
        global: {
          localization: wdrEs
        },
        report: {
          options: {
            grid: {
              type: "compact",
              showHeaders: false,
              showTotals: "on",
              showGrandTotals: "off",
              title: title
            },
            configuratorButton: false
          },
          dataSource: {
            data: data
          },
          slice: {
            rows: [{ uniqueName: "categoria" }],
            columns: [{ uniqueName: "Measures" }],
            measures: [
              {
                uniqueName: "metrica_10",
                caption: "> 4000",
                individual: true,
                formula: 'IF("metrica_id" == 10, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_20",
                caption: "1000-3999",
                individual: true,
                formula: 'IF("metrica_id" == 20, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_30",
                caption: "750-999",
                individual: true,
                formula: 'IF("metrica_id" == 30, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_40",
                caption: "500-749",
                individual: true,
                formula: 'IF("metrica_id" == 40, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_50",
                caption: "250-499",
                individual: true,
                formula: 'IF("metrica_id" == 50, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_60",
                caption: "100-249",
                individual: true,
                formula: 'IF("metrica_id" == 60, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_70",
                caption: "Subtotal > 99",
                individual: true,
                formula: 'IF("metrica_id" == 70, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_80",
                caption: "60-99",
                individual: true,
                formula: 'IF("metrica_id" == 80, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_90",
                caption: "0-59",
                individual: true,
                formula: 'IF("metrica_id" == 90, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_100",
                caption: "Total Productores",
                individual: true,
                formula: 'IF("metrica_id" == 100, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_110",
                caption: "Agentes",
                individual: true,
                formula: 'IF("metrica_id" == 110, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_120",
                caption: "Comercios",
                individual: true,
                formula: 'IF("metrica_id" == 120, "valor", 0)',
                aggregation: "sum",
                format: "f_valor"
              },
              {
                uniqueName: "metrica_130",
                caption: "Total General",
                individual: true,
                formula: 'IF("metrica_id" == 130, "valor", 0)',
                aggregation: "sum",
                format: "f_importe"
              }
            ],
            expands: {
              expandAll: true
            }
          },
          formats: [
            {
              name: "f_importe",
              thousandsSeparator: ".",
              decimalSeparator: ",",
              decimalPlaces: 2,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_valor",
              thousandsSeparator: ".",
              decimalPlaces: 0,
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: false
            },
            {
              name: "f_porcentaje",
              thousandsSeparator: ".",
              decimalPlaces: 2,
              decimalSeparator: ",",
              currencySymbol: "",
              currencySymbolAlign: "left",
              nullValue: "",
              textAlign: "right",
              isPercent: true
            }
          ]
        }
      });
    },

    unloadPivotTable() {
      this.pivot = null;
    },

    customizeToolbar(toolbar) {
      var tabs = toolbar.getTabs();
      tabs.forEach((tab, index) => {
        if (!(tab.id == "wdr-tab-fullscreen" || tab.id == "wdr-tab-export")) {
          delete tabs[index];
        }
      });
      toolbar.getTabs = function() {
        return tabs;
      };
    },

    async loadColumns() {
      let columns = null,
        newColumn = null,
        defaultColumn = null;
      this.estimationColumnsItems = [];
      this.selectedEstimationColumn = null;
      this.filterEstimationClolumn = null;

      try {
        //load columns
        columns = await this.$bRoot.search(
          "/data/estimations_columns",
          null,
          "number",
          "campaign__id=" + this.filterCampaign.id.toString()
        );

        if (columns.data.count !== 12) {
          this.canEdit = false;
          throw "Error recuperando configuración de columnas para " +
            this.filterCampaign.description.toString() +
            " contacte al administrador";
        }

        columns.data.results.map(item => {
          newColumn = {
            id: item.number,
            code: "col" + item.number.toString(),
            description: item.description
          };
          this.estimationColumnsItems.push(newColumn);
          if (
            this.$moment().isBetween(
              this.$moment(item.editable_from),
              this.$moment(item.editable_to)
            ) &&
            !defaultColumn
          ) {
            defaultColumn = newColumn;
          }
        });

        //set default
        if (defaultColumn) {
          this.selectedEstimationColumn = defaultColumn.code;
          this.filterEstimationClolumn = defaultColumn;
        }
      } catch (error) {
        if (!this.$bRoot.errors) {
          this.$bRoot.setError(error);
        }
      }
    }
  },

  async mounted() {
    var main_container = document.getElementById("app");
    main_container.classList.remove("home");

    this.current_level = this.$bRoot.auth.current_level;
    let campaigns = null,
      crops = null,
      index = -1;

    try {
      //load campaigns
      campaigns = await this.$bRoot.search("/data/campaigns", null, "-code");
      this.campaignItems = campaigns.data.results;

      //set default
      let defaultCampaignId = this.$bRoot.getUserParam("defaultCampaignId");
      index = this.campaignItems.findIndex(item => item.id == defaultCampaignId);
      if (index == -1) {
        index = this.campaignItems.findIndex(item => item.current === true);
      }
      if (index !== -1) {
        this.selectedCampaign = this.campaignItems[index].url;
        this.filterCampaign = this.campaignItems[index];
      }

      //Refresh Campaign Segmentation
      this.refreshCampaignSegmentation();

      //load crops
      crops = await this.$bRoot.search("/data/crops", null, "description");
      this.cropItems = crops.data.results;

      //set default
      let defaultCropId = this.$bRoot.getUserParam("defaultCropId");
      index = this.cropItems.findIndex(item => item.id === defaultCropId);
      if (index !== -1) {
        this.selectedCrop = this.cropItems[index].url;
        this.filterCrop = this.cropItems[index];
      }

      //load commercial persons
      let commercialPersons = await this.$bRoot.searchAll(
        "/data/commercial_persons_hierarchy",
        null,
        "name",
        "commercial_type_level__lt=4"
      );
      this.commercialPersonItems = commercialPersons;

      //Columns
      await this.loadColumns();

      await this.readDataFromAPI();
    } catch (error) {
      if (!this.$bRoot.errors) {
        this.$bRoot.setError(error);
      }
    } finally {
      this.loading = false;
    }
  }
};
</script>
<style>
.wdr-credits {
  display: none;
}
#wdr-pivot-view #wdr-grid-view div.alter1 {
  background-color: #eff9ff;
}
#wdr-pivot-view #wdr-grid-view div.alter2 {
  background-color: #cceeff;
}
#wdr-pivot-view #wdr-grid-view div.alter3 {
  background-color: #b4e3fa;
}
</style>
